export default __webpack_public_path__ + "locales/pt/SendInviteDialog.json?hash=35dccfc14c3b68201e828a71c674a9df";